import { Fonts, SvgIcon, Text, TextSize, Weight } from 'components'
import styled, { css } from 'styled-components'

export const StyledSvgIcon = styled(SvgIcon)`
  margin-bottom: 20px;
  height: 90px;
  svg {
    height: 85px;
    width: auto;
  }
`

export const StyledAiPoweredIcon = styled(SvgIcon)`
  margin-bottom: 20px;
  height: 90px;
  svg {
    height: 100px;
    width: auto;
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  height: auto;
  min-height: 340px;
  ${({ theme }) => theme.mediaWidth.Mobile`
    height: 100%;
    max-height: 1000px;
    margin-top: 30px;
  `};
`

export const InfoIconItem = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  text-align: center;
  ${({ theme }) => theme.mediaWidth.Tablet`
    max-width: 220px;
  `};
`

export const InfoIconsContainer = styled.div`
  display: flex;
  margin-top: 15px;
  ${({ theme }) => theme.mediaWidth.Tablet`
    justify-content: space-between
  `};
  ${({ theme }) => theme.mediaWidth.Desktop`
    gap: 90px;
  `};
  ${({ theme }) => theme.mediaWidth.Mobile`
    margin-bottom: 15px;
    flex-direction: column;
    gap: 30px;
  `};
`

export const ExposureText = styled(Text)`
  color: ${({ theme }) => theme.secondaryText};
  font-size: ${TextSize.small};
  ${({ theme }) => theme.mediaWidth.Mobile`
    max-width: 180px;
    text-align: center;
    margin: 0 auto;
  `};
`

export const GradientText = styled.span<{
  isCapitalized: boolean
  color: string
  fontSize?: string
}>`
  font-family: ${Fonts.DMSans};
  font-weight: ${Weight.Bold};
  letter-spacing: -0.04em;
  background: ${({ color }) => color};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-right: 5px;
  font-size: ${({ fontSize }) => fontSize ?? TextSize.two};
  ${({ isCapitalized }) =>
    isCapitalized &&
    css`
      :first-letter {
        text-transform: capitalize;
      }
    `}
  ${({ theme }) => theme.mediaWidth.Tablet`
    font-size: 28px;
    margin-right: 0;
  `};
`

export const Title = styled(Text)`
  font-size: ${TextSize.two};
  font-weight: ${Weight.Bold};
  line-height: 26px;
  margin-bottom: 15px;
  ${({ theme }) => theme.mediaWidth.Tablet`
    height: 52px;
  `};
`

export const StyledTitle = styled(Title)`
  display: flex;
  flex-direction: column;
  align-items: center;
`
